import { SwgyHeadersKeys } from "@swiggy-private/core-types";
import { isEmpty } from "@swiggy-private/core-ui";

export type SwgyHeaderType = { [key in Partial<SwgyHeadersKeys>]: string };
let swiggyHeaders: SwgyHeaderType = {} as SwgyHeaderType;

const setHeader = (): void => {
    if (!isEmpty(window.__headers__)) {
        swiggyHeaders = window.__headers__ as SwgyHeaderType;
    }
};

export class GlobalHeaderState {
    static init(initialHeaders: SwgyHeaderType): void {
        if (initialHeaders) {
            swiggyHeaders = initialHeaders;
        }
    }

    static getHeaders = (): SwgyHeaderType => {
        if (!swiggyHeaders) {
            setHeader();
        }

        return swiggyHeaders;
    };

    static getHeader = (key: string): string => {
        if (!swiggyHeaders) {
            setHeader();
        }

        if (typeof key !== "string" || !swiggyHeaders) {
            throw new Error(`Error while getting header with ${key}`);
        }

        return swiggyHeaders[key.toLowerCase() as SwgyHeadersKeys];
    };

    /*
     * This function is added to support updating headers realtime as a requirement mainly in swiggy money mandates
     * where the businessline updates dynamically depending on user's actions. e.g., clicking on add swiggy
     * money cta, will update businessline to swiggy money, and coming back to payments or after topup successful,
     * the businessline will be reset again to original business line.
     */
    static updateHeaders = (params: { [key: string]: string | null }): void => {
        const currentHeaders = GlobalHeaderState.getHeaders();
        swiggyHeaders = {
            ...currentHeaders,
            ...(params as Record<string, string>),
        };
        window.__headers__ = swiggyHeaders as SwgyHeaderType;
    };

    static setHeader = (key: SwgyHeadersKeys, value: string): void => {
        if (typeof key !== "string" || typeof value !== "string" || !swiggyHeaders) {
            throw new Error(`Error while setting header with ${key} ${value}`);
        }

        swiggyHeaders[key] = value;
    };

    static removeHeader = (key: SwgyHeadersKeys): void => {
        delete swiggyHeaders[key];
    };
}
